import subscriptionModule from "../subscriptionModule";

function subscriptionContainer(premiumConstants) {
    "ngInject";

    return {
        restrict: "A",
        templateUrl: premiumConstants.templates.subscriptionContainer,
        link: function (scope, elem, attr) {
            scope.isStarcodeMobileEnabled = attr.isStarcodeMobileEnabled === 'true';
        }
    }
}

subscriptionModule
    .directive("subscriptionContainer", subscriptionContainer);

export default subscriptionContainer;